import { useState, useEffect } from "react";
import { Typography, Button, Card, Input } from "antd";

import HeaderItems from "../../../../assets/images/header-items";
import { ReactComponent as SearchIcon } from "../../../../assets/images/search.svg";
import SingleApproveSubmissionCard from "./SingleApproveSubmissionCard";

const { Text } = Typography;

const ApproveUserSubmission = ({
  users,
  approveTaskSubmit,
  loading,
  taskId,
}: any) => {
  const [filteredUsers, setFilteredUsers] = useState<any>(users);
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("ALL");
  const filterProps = [
    { key: "ALL", value: "ALL" },
    { key: "IN PROGRESS", value: "IN PROGRESS" },
    { key: "SUBMITTED", value: "SUBMITTED" },
    { key: "APPROVED", value: "APPROVED" },
  ];
  const allSubmissions = filterProps[0];
  const inProgressSubmissions = filterProps[1];
  const submittedSubmissions = filterProps[2];
  const approvedSubmissions = filterProps[3];

  useEffect(() => {
    let filtered = users;

    if (filter === "APPROVED") {
      filtered = filtered.filter(
        (user: any) => user.isFinished && user.isApproved
      );
    } else if (filter === "IN PROGRESS") {
      filtered = filtered.filter(
        (user: any) => !user.isFinished && !user.isApproved
      );
    } else if (filter === "SUBMITTED") {
      filtered = filtered.filter(
        (user: any) => user.isFinished && !user.isApproved
      );
    }

    if (searchTerm) {
      filtered = filtered.filter((user: any) =>
        user.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredUsers(filtered);
  }, [users, searchTerm, filter]);

  const handleApproveSubmit = (submissionId: string, isApproved: boolean) => {
    approveTaskSubmit({ submissionId, isApproved, taskId });
  };

  return (
    <>
      <div className="sticky">
        <Input
          placeholder="Search"
          prefix={<SearchIcon className="mx-3" />}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div className="flex gap-5 my-5">
          <Button
            type="link"
            onClick={() => {
              setFilter(allSubmissions.value);
            }}
            className={
              filter === allSubmissions.value
                ? "text-primary-600 font-semibold px-0 text-sm"
                : "text-neutral-400 font-normal px-0 text-sm"
            }
          >
            {allSubmissions.key}
          </Button>
          <Button
            type="link"
            onClick={() => {
              setFilter(inProgressSubmissions.value);
            }}
            className={
              filter === inProgressSubmissions.value
                ? "text-primary-600 font-semibold px-0 text-sm"
                : "text-neutral-400 font-normal px-0 text-sm"
            }
          >
            {inProgressSubmissions.key}
          </Button>

          <Button
            type="link"
            onClick={() => {
              setFilter(submittedSubmissions.value);
            }}
            className={
              filter === submittedSubmissions.value
                ? "text-primary-600 font-semibold px-0 text-sm"
                : "text-neutral-400 font-normal px-0 text-sm"
            }
          >
            {submittedSubmissions.key}
          </Button>

          <Button
            type="link"
            onClick={() => {
              setFilter(approvedSubmissions.value);
            }}
            className={
              filter === approvedSubmissions.value
                ? "text-primary-600 font-semibold px-0 text-sm"
                : "text-neutral-400 font-normal px-0 text-sm"
            }
          >
            {approvedSubmissions.key}
          </Button>
        </div>

        <div>
          <div className="flex flex-col gap-4 pb-[60px overflow-y-scroll max-h-[calc(100vh-290px)]">
            {filteredUsers && filteredUsers.length > 0 ? (
              filteredUsers.map((submission: any, index: number) => (
                <SingleApproveSubmissionCard
                  key={index}
                  handleApproveSubmit={handleApproveSubmit}
                  submission={submission}
                  loading={loading}
                />
              ))
            ) : (
              <Card className="shadow-md py-[60px]">
                <div className={`px-[40px]`}>
                  <div className="flex flex-col gap-10 items-center justify-center">
                    <div className="h-[60px]">
                      <HeaderItems.Task className="text-[80px] text-primary-500" />
                    </div>
                    <Text className="text-neutral-600 text-xl font-bold text-center">
                      There are currently no available Tasks
                    </Text>
                  </div>
                </div>
              </Card>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ApproveUserSubmission;
